import type { BillingDocumentStatus, BillingDocumentType } from './billingService';

export type PolarDisplayDoc = {
  doc_type: BillingDocumentType;
  status: BillingDocumentStatus;
  number: string | null;
  polar_quote_id: string | null;
  polar_invoice_id: string | null;
};

export function polarDocumentNumber(doc: Pick<PolarDisplayDoc, 'number'>): string | null {
  const n = doc.number?.trim();
  return n ? n : null;
}

export function polarStatusLabel(doc: PolarDisplayDoc): string {
  if (doc.status === 'paid') return 'Payée';
  if (doc.status === 'overdue') return 'En retard';
  if (doc.status === 'void') return 'Annulée';
  if (doc.status === 'rejected') return 'Refusé';
  if (doc.status === 'accepted') return 'Accepté';
  if (doc.status === 'sent') return 'Envoyé';
  if (polarDocumentNumber(doc) && (doc.polar_quote_id || doc.polar_invoice_id)) {
    return 'Figé';
  }
  return 'Brouillon';
}

export function polarPdfId(doc: Pick<PolarDisplayDoc, 'polar_quote_id' | 'polar_invoice_id'>): number | null {
  const raw = doc.polar_invoice_id ?? doc.polar_quote_id;
  if (!raw) return null;
  const id = Number(raw);
  return Number.isFinite(id) ? id : null;
}

/** Id Polar à envoyer : devis = quote, facture = invoice (jamais l’autre pièce). */
export function polarSendId(
  doc: Pick<PolarDisplayDoc, 'doc_type' | 'polar_quote_id' | 'polar_invoice_id'>,
): number | null {
  const raw = doc.doc_type === 'invoice' ? doc.polar_invoice_id : doc.polar_quote_id;
  if (!raw) return null;
  const id = Number(raw);
  return Number.isFinite(id) ? id : null;
}
